/***
 * Created on 2024/2/19
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import ModalDialog from "../../../../common/modal_dialog/modalDialog";
import totp_svg from '../../../../../static/img/utils/ic-2-step-method--totp.svg';
import qrcode_svg from '../../../../../static/img/utils/ic-2-step-method--qrcode.svg';
import approval_svg from '../../../../../static/img/utils/ic-2-step-method--login-approve.svg';
import verification_svg from '../../../../../static/img/utils/ic-2-step-method--online-verification-code.svg';
import {useTranslation} from "react-i18next";
import {usePreCheckPassword} from "../../../../../hook/pre_check_password";
import {getLocalUser} from "../../../../../service/user";

function InitQnapAuthAppSetup({dispatch, state, ...props}) {
    const { t } = useTranslation();
    const {checkPassword} = usePreCheckPassword();

    const selectVerifyMethod = (method) => {
        const user = getLocalUser();
        if (Object.keys(user?.secure?.qnap_auth?.devices || {}).length > 0 && method !== 'totp' && !state?.newDevice) {
            dispatch({
                type: "toggleManageSetup",
                value: true,
                method: method
            })
        }
        else {
            dispatch({
                type: "toggleShowInstallApp",
                value: true,
                openAfterInstallApp: "toggleShowQrCodeScan",
                method: method
            })
        }
    }

    return (
        <ModalDialog {...props} title={t('@Select a verification method@')} hideSubmit={true}>
            <div className="dialog-content dialog-content--two-step">
                <div className="two-step-methods">
                    { !state?.newDevice &&
                        <>
                            <p className="!mb-16">{t('@Through the TOTP without connecting to the internet@')}</p>
                            <div className="two-step-methods__item" onClick={() => selectVerifyMethod('totp')}>
                                <div className="two-step-methods__item__ic">
                                    <img src={totp_svg} alt="" />
                                </div>
                                <div>
                                    <div className="text-16 font-medium mb-8">{t('@TOTP Passcode@')}</div>
                                    <div>{t('@Secure login with dynamic, time-based passcodes using a TOTP-compatible app.@')}</div>
                                </div>
                            </div>
                        </>
                    }
                    <p className="!mb-16">{t('@Through the online verification services provided by QNAP@')} </p>
                    <div className="two-step-methods__item" onClick={() => selectVerifyMethod('qrcode')}>
                        <div className="two-step-methods__item__ic">
                            <img src={qrcode_svg} alt="" />
                        </div>
                        <div>
                            <div className="text-16 font-medium mb-8">{t('@QR Code@')}</div>
                            <div>
                                {t('@Eliminating the need for manual code entry, complete the process with a quick scan of the QR Code@')}
                            </div>
                        </div>
                    </div>
                    <div className="two-step-methods__item" onClick={() => selectVerifyMethod('approval')}>
                        <div className="two-step-methods__item__ic">
                            <img src={approval_svg} alt="" />
                        </div>
                        <div>
                            <div className="text-16 font-medium mb-8">{t('@Login Approve@')}</div>
                            <div>
                                {t("@Seamless authentication by simply tapping the 'Approve' button on your paired mobile device@")}
                            </div>
                        </div>
                    </div>
                    <div className="two-step-methods__item" onClick={() => selectVerifyMethod('verification')}>
                        <div className="two-step-methods__item__ic">
                            <img src={verification_svg} alt="" />
                        </div>
                        <div>
                            <div className="text-16 font-medium mb-8">{t('@Online Verification Code@')}</div>
                            <div>{t('@Optimize security with real-time passcodes sent via push notifications@')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </ModalDialog>
    );
}

export default InitQnapAuthAppSetup;